import React, { useEffect, useState } from "react";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FaCalendarAlt } from 'react-icons/fa';
import { epochToCRMDatetimeStrTz } from '../utils/util';

const DateComponent = (props) => {
  const { scheduledDate } = props;
  const [selectedDate, setSelectedDate] = useState(null);
  const [_scheduledDate, setScheduledDate] = useState(null);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    props.onChange((new Date(date).getTime())/ 1000);
  };

  const handleClearDate = () => {
    setSelectedDate(null);
    setScheduledDate(null);
  };

  useEffect(() => {
    setScheduledDate(scheduledDate);
  }, []);

  return (
    <div className="date-picker-container">
      <DatePicker
        selected={selectedDate ? selectedDate : (_scheduledDate ? new Date(epochToCRMDatetimeStrTz(_scheduledDate, true)) : null)}
        onChange={handleDateChange}
        dateFormat="dd/MM/yyyy"
        customInput={<CustomInput 
            handleClearDate={handleClearDate}
        />}
      />
      {/* <Button onClick={handleClearDate} color="secondary">
        <RiDeleteBack2Line/>      
      </Button> */}
    </div>
  );
};

const CustomInput = ({ value, onClick, handleClearDate }) => (
  <div style={{ position: 'relative' }}>
    <input
      style={{
        border: '1px solid #cccccc',
        padding: '8px',
        width: '130px',
        borderRadius: '4px',
      }}
      type="text"
      value={value}
      readOnly={true}
      onClick={onClick}
    />
    <div
      style={{
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        padding: '8px',
        borderLeft: '1px solid #ced4da',
        cursor: 'pointer',
      }}
      onClick={onClick}
    >      
      {/* <Button style={{ position: "absolute", top: ".5rem", margin: "auto", right: "2rem" }} onClick={() => handleClearDate()}>
        <RiDeleteBack2Line />
      </Button>       */}
      <FaCalendarAlt style={{ color: '#495057' }} />
    </div>
  </div>
);


export default DateComponent;
